<!--  -->
            
<template>
<div class="row">
    <div class="text-center">
    <v-overlay 
        :value="overlay"
        :opacity=0.1
    >
      
    </v-overlay>
  </div>
  <v-card
    class="mx-auto col-md-8 mb-12 mt-12"
    style=" z-index:10; padding:50px;"
    center
  >
    <v-card-text class="mb-12">
      <!-- <div>Word of the Day</div> -->
      <div class="row">
        <div class="col-md-8">
            <p 
            class="mb-12"
            style="color: #55636b;
                font-size: 28px;
                font-weight: 300;
                line-height: normal;"
            >
                To use RubiesCircle on your computer:
            </p>

            <div class="text--primary" style="font-size: 18px;">
               <ol class="mb-12">
                   <li class="mb-5">Open RubiesCircle on your phone</li>
                   <li class="mb-5"><span dir="ltr" class="selectable-text invisible-space copyable-text">Tap <strong><span dir="ltr" class="selectable-text invisible-space copyable-text">Menu <span class="_3PxOr"><svg height="24px" viewBox="0 0 24 24" width="24px"><rect fill="#f2f2f2" height="24" rx="3" width="24"></rect>
                   <path d="m12 15.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm0-2c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5zm0-5c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5z" fill="#818b90"></path></svg></span></span>
                   </strong> or <strong><span dir="ltr" class="selectable-text invisible-space copyable-text">Settings <span class="_3PxOr"><svg width="24" height="24" viewBox="0 0 24 24"><rect fill="#F2F2F2" width="24" height="24" rx="3"></rect><path d="M9.34 8.694a4.164 4.164 0 0 0-1.606 3.289c0 1.338.63 2.528 1.61 3.292l-1.46 2.527a7.065 7.065 0 0 1-3.052-5.82c0-2.41 1.206-4.54 3.048-5.816l1.46 2.528zm6.713 2.859c-.217-2.079-1.992-3.739-4.148-3.739-.578 0-1.128.116-1.628.329L8.819 5.617a7.042 7.042 0 0 1 3.086-.704c3.76 0 6.834 2.958 7.059 6.64h-2.91zm-1.065.43a3.083 3.083 0 1 1-6.166 0 3.083 3.083 0 0 1 6.166 0zm-6.164 6.364l1.458-2.523a4.153 4.153 0 0 0 1.623.322 4.154 4.154 0 0 0 4.12-3.524h2.922a7.062 7.062 0 0 1-7.042 6.426c-1.105 0-2.15-.25-3.081-.7zm11.197-7.21a7.88 7.88 0 0 0-.404-1.824l.286-.12a.527.527 0 0 0-.403-.973l-.29.12a8.176 8.176 0 0 0-1.197-1.77l.231-.23a.526.526 0 1 0-.744-.744l-.234.234a8.17 8.17 0 0 0-1.775-1.18l.13-.31a.526.526 0 1 0-.972-.403l-.12.313a8.463 8.463 0 0 0-1.995-.405v-.35A.533.533 0 0 0 12 2.97a.533.533 0 0 0-.535.526v.338a8.02 8.02 0 0 0-2.173.416l-.13-.313a.526.526 0 0 0-.972.402l.129.311a8.171 8.171 0 0 0-1.775 1.18l-.235-.235a.526.526 0 0 0-.743.744l.23.231A8.175 8.175 0 0 0 4.6 8.34l-.29-.12a.526.526 0 0 0-.403.971l.285.122a7.882 7.882 0 0 0-.404 1.824h-.322a.533.533 0 0 0-.526.534c0 .29.235.535.526.535h.28c.02.831.166 1.624.418 2.378l-.257.1a.523.523 0 1 0 .402.968l.252-.105a8.17 8.17 0 0 0 1.191 1.797l-.187.187a.526.526 0 1 0 .744.743l.184-.183a8.173 8.173 0 0 0 1.792 1.208l-.096.231a.526.526 0 1 0 .972.403l.096-.23c.698.24 1.436.387 2.208.428v.243c0 .29.244.526.535.526.29 0 .534-.235.534-.526v-.253a8.012 8.012 0 0 0 2.03-.417l.09.229a.523.523 0 1 0 .967-.403l-.096-.231a8.172 8.172 0 0 0 1.792-1.208l.184.183a.526.526 0 1 0 .743-.744l-.187-.186a8.174 8.174 0 0 0 1.191-1.798l.252.104a.526.526 0 1 0 .403-.971l-.257-.095a8.074 8.074 0 0 0 .417-2.378h.281c.29 0 .526-.244.526-.535a.533.533 0 0 0-.526-.534h-.323z" fill="#818B90"></path></svg></span></span>
                   </strong> and select <strong>Scan QR-Code</strong></span></li>
                   <li class="mb-5">Point your phone to this screen to capture the code</li>
                </ol>
            </div>

            <a href="#" style="style:none;" target="_blank">Need help to get started?</a>
        </div>
        <div class="col-md-4">
            <v-layout column align-center justify-center>
            <v-card height="250" width="290">
            <v-layout justify-center wrap>
                <qrcode-vue :value="value" :size="size" class="qr" level="H"  align="center"></qrcode-vue>

                <v-overlay
                :absolute="qr.absolute"
                :opacity="qr.opacity"
                :value="qr.overlay"
                >
                <v-flex xs12 sm12
                    style="background-color:#fff;  width:200px; height:200px; padding: 70px; border-radius: 100px; border-style: none;"
                >
                    <v-btn  @click="refreshqr" text icon color="#6D0606" >
                        <v-icon  style="font-size: 100px;">cached</v-icon>
                    </v-btn>
                </v-flex>
                </v-overlay>
            </v-layout>
            </v-card>
  </v-layout>
        </div>
      </div>
    </v-card-text>
    <v-divider class="mb-12"></v-divider>
    <template class="mt-12" style="margin-top: 40px; background-color: '#eee';">
    <v-layout align-center justify-center>
        <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/qGaFH6gYG14" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-layout>
    </template>
  </v-card>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

  export default {
    name: 'login',
    components: {
        QrcodeVue
    },
    data() {
      return {
        //for loader
        count:0,
        hibernate:false,
        qr:{
            absolute: true,
            opacity: 0.7,
            overlay: false,
        },
        absolute: true,
        overlay: true,
        isLoading: false,
        reverse: true,
        fullPage: true,
        fs: String,
        ls: String,
        //end for loader
        model: {
          email: '',
          password: ''
        },
        User: {},
        value: localStorage.deviceID,
        size: 250,
        deviceid: localStorage.deviceID,
        options: [],
      
      dataos: [
          { name: 'Windows Phone', value: 'Windows Phone', version: 'OS' },
          { name: 'Windows', value: 'Win', version: 'NT' },
          { name: 'iPhone', value: 'iPhone', version: 'OS' },
          { name: 'iPad', value: 'iPad', version: 'OS' },
          { name: 'Kindle', value: 'Silk', version: 'Silk' },
          { name: 'Android', value: 'Android', version: 'Android' },
          { name: 'PlayBook', value: 'PlayBook', version: 'OS' },
          { name: 'BlackBerry', value: 'BlackBerry', version: '/' },
          { name: 'Macintosh', value: 'Mac', version: 'OS X' },
          { name: 'Linux', value: 'Linux', version: 'rv' },
          { name: 'Palm', value: 'Palm', version: 'PalmOS' }
      ],
      databrowser: [
          { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
          { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
          { name: 'Safari', value: 'Safari', version: 'Version' },
          { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
          { name: 'Opera', value: 'Opera', version: 'Opera' },
          { name: 'BlackBerry', value: 'CLDC', version: 'CLDC' },
          { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' }
      ],
      header: [
          navigator.platform,
          navigator.userAgent,
          navigator.appVersion,
          navigator.vendor,
          window.opera
      ],

      formData:{
        osname: "",
        osversion: "",
        browsername: "",
        browserversion: "",
        vendor: "",
        platform: "",
        mobilenumber: "",
        deviceID: ""
      }
      }
    },
    methods: {
        logon(){
            if(this.count < 70){
                    
            fetch('https://shwvr4uwyh.execute-api.us-east-1.amazonaws.com/dev/checkbrowser',{
                method: 'post',
                body: JSON.stringify(this.formData),
                headers: {
                'content-type':'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                console.log(res);
                
                if( this.objsize(res) > 0)
                {
                    if (res.data[0].mobilenumber != "") {
                        let phonenumber = res.data[0].mobilenumber;
                        console.log(res);
                        localStorage.auth = true;
                        localStorage.phonenumber = phonenumber;
                        this.fs = res.firstname;
                        this.ls = res.lastname;
                        this.fs = this.fs.charAt(0);
                        this.ls = this.ls.charAt(0);
                        localStorage.avatar = this.fs +this.ls;
                        this.$router.push('mygroups');
                    this.count++;
                    }else{
                        this.count++;
                        this.logon();
                    }
                    
                }else{
                    this.count++;
                    this.logon();
                }
            })
            .catch(err => console.log(err))
            }else{
                this.qr.overlay = true;
            }
        },

    generateDeviceID: function () {
      var e = this.init();
      this.formData.osname = e.os.name;
      this.formData.osversion = e.os.version;
      this.formData.browsername = e.browser.name;
      this.browserversion = e.browser.version;
      this.formData.vendor = navigator.vendor;
      this.formData.platform = navigator.platform;
      // mobilenumber = e.os.mobilenumber;
      if (localStorage.deviceID != null) {
        this.formData.deviceID = localStorage.deviceID;
      }else{
        this.formData.deviceID =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.deviceID = this.formData.deviceID;
      }
    
    },
    objsize: function(Myobj) {
        var osize = 0, key;
        for (key in Myobj) {
            if (Myobj.hasOwnProperty(key)) osize++;
        }
        return osize;
    },
    matchItem: function (string, data) {
            var i = 0,
                j = 0,
                html = '',
                regex,
                regexv,
                match,
                matches,
                version;
            
            for (i = 0; i < data.length; i += 1) {
                regex = new RegExp(data[i].value, 'i');
                match = regex.test(string);
                if (match) {
                    regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                    matches = string.match(regexv);
                    version = '';
                    if (matches) { if (matches[1]) { matches = matches[1]; } }
                    if (matches) {
                        matches = matches.split(/[._]+/);
                        for (j = 0; j < matches.length; j += 1) {
                            if (j === 0) {
                                version += matches[j] + '.';
                            } else {
                                version += matches[j];
                            }
                        }
                    } else {
                        version = '0';
                    }
                    return {
                        name: data[i].name,
                        version: parseFloat(version)
                    };
                }
            }
            return { name: 'unknown', version: 0 };
        },
    init: function () {
            var agent = this.header.join(' '),
                os = this.matchItem(agent, this.dataos),
                browser = this.matchItem(agent, this.databrowser);
            
            return { os: os, browser: browser };
        },
    refreshqr(){
        this.qr.overlay = false;
        this.count = 0;
        this.formData.deviceID =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.deviceID = this.formData.deviceID;
        this.value = localStorage.deviceID,
        this.logon();
    }
    },
    computed: {
        
    },
    created() {
        
    },
    mounted() {

        this.generateDeviceID();
        this.logon();

    },
}
</script>
<style>
</style>
